import _ from 'lodash';
import moment from 'moment/moment';

import { serverDateTimeToLocalMoment } from '~/DateTimeUtils';

export const useReplyEmailText = (communication) => {
  const emailHtmlBody = communication.body_html
    ? communication.body_html
    : '<div>' + _.escape(communication.body_text).replace(/(\r\n|\n)/g, '<br/>') + '</div>';

  let origEmailSender = undefined;
  if (communication.direction === 'Outgoing') {
    origEmailSender = `${communication.adjuster} <${communication.adjuster_email}>`;
  } else {
    //Incoming
    origEmailSender = communication.contact // can be undefined in case of reply to unknown email
      ? `${communication.contact.full_name} <${communication.contact_email.email}>`
      : `${communication.specific_identifier} <${communication.specific_identifier}>`;
  }

  const emailText =
    '<span>------------------------------------------------------------------------</span><br/>' +
    `On ${moment(serverDateTimeToLocalMoment(communication.datetime)).format(
      'dddd, MMMM D, YYYY [at] h:mm:ss A'
    )} ${_.escape(origEmailSender)} wrote:` +
    `<br/><br/>${emailHtmlBody}`;

  return { emailText };
};
